module.exports = __webpack_public_path__ + "static/media/WhoAreWe2.8a87a953.svg";